import {
  INITIATE_LOGIN,
  INVALIDATE_LOGIN,
  INITIATE_RESET_PASSWORD,
  RESET_EMAIL_SENT,
  RESET_EMAIL_ERROR,
} from './actionTypes';
import toFinish from '../utils/toFinish';
import auth from '../utils/auth';

const initiateLogin = () => ({
  type: INITIATE_LOGIN,
});

const invalidateLogin = message => ({
  type: INVALIDATE_LOGIN,
  payload: {
    message,
  },
});

export const submitLogin = (email, password) => async (dispatch) => {
  dispatch(initiateLogin());
  const [loginError, loginResp] = await toFinish(auth.login(email, password));
  if (loginError) {
    return dispatch(invalidateLogin('Something went wrong. Please try again.'));
  }

  const { valid, error, newUser } = loginResp;
  if (valid) {
    if (newUser) {
      window.location.replace('/set_profile');
    } else {
      window.location.replace('/overview');
    }
    return true;
  }
  return dispatch(invalidateLogin(error));
};

const initiateResetPassword = () => ({
  type: INITIATE_RESET_PASSWORD,
});

const resetEmailSent = message => ({
  type: RESET_EMAIL_SENT,
  payload: {
    message,
  },
});

const resetEmailError = message => ({
  type: RESET_EMAIL_ERROR,
  payload: {
    message,
  },
});

export const resetPassword = email => async (dispatch) => {
  dispatch(initiateResetPassword());
  const [resetErr, resetRes] = await toFinish(auth.resetPassword(email));
  if (resetErr) return dispatch(resetEmailError(resetErr.message));
  return dispatch(resetEmailSent(resetRes));
};



// WEBPACK FOOTER //
// ./src/actions/auth.js